// Stripe pricing configuration - Updated January 2026
// New pricing: Monthly $5.99, Quarterly $13.99 (22% off), Annual $44.99 (37% off)
export const STRIPE_PRICES = {
  monthly: {
    priceId: 'price_1SmKUL9TqlPY6UJr6Wzixtfm',
    productId: 'prod_Tjo6DcUQBqRmiV',
    amount: 5.99,
    interval: 'month' as const,
    displayName: 'Monthly',
    description: 'Billed monthly',
    savings: null,
    popular: false,
  },
  quarterly: {
    priceId: 'price_1SmKUY9TqlPY6UJrWPw5hKUo',
    productId: 'prod_Tjo6v5ZGQPqCZ3',
    amount: 13.99,
    interval: 'quarter' as const,
    displayName: 'Quarterly',
    description: 'Billed every 3 months',
    savings: 'Save 22%',
    popular: false,
  },
  annual: {
    priceId: 'price_1SmKUk9TqlPY6UJrgkPVKogY',
    productId: 'prod_Tjo6ebkuXXFJvR',
    amount: 44.99,
    interval: 'year' as const,
    displayName: 'Annual',
    description: 'Billed yearly',
    savings: 'Save 37%',
    popular: true,
  },
} as const;

export type PricingTier = keyof typeof STRIPE_PRICES;

// Student discount: Use code STUDENT30 at checkout for 30% off first 3 months
// Stripe coupon ID: aHMnL8Bt
